import React, { useState } from "react";
import { ReactReader } from "react-reader";
import { useParams } from "react-router";

const EpubReader = (props) => {
  const code = useParams().code;

  const [location, setLocation] = useState(
    localStorage && localStorage.getItem(code + "-epub-location")
      ? localStorage.getItem(code + "-epub-location")
      : 1
  );
  const onLocationChanged = (location) => {
    setLocation(location);
    localStorage && localStorage.setItem(code + "-epub-location", location);
  };

  const epub = code + ".epub";
  return (
    <div style={{ position: "relative", height: "80vh" }}>
      <ReactReader
        url={process.env.REACT_APP_API_URL + "/epub/books/" + epub}
        locationChanged={onLocationChanged}
        location={location}
      />
    </div>
  );
};

export default EpubReader;
